import { assetMatchesAssetTypes } from './MakeModelNestedFilter/utils';

type AssetType = {
  id?: string | null;
  name?: string | null;
};

type AssetWithType = {
  assetType?: AssetType | null;
};

const PREFERRED_ASSET_TYPE_ORDER = ['Turbine', 'Blade'];

export const orderAssetTypesForFilter = <T extends AssetType>(assetTypes: T[]): T[] => [
  ...PREFERRED_ASSET_TYPE_ORDER.flatMap(name =>
    assetTypes.filter(assetType => assetType.name === name)
  ),
  ...assetTypes.filter(assetType => !PREFERRED_ASSET_TYPE_ORDER.includes(assetType.name ?? '')),
];

export const filterAssetsByTypes = <T extends AssetWithType>(
  assets: T[],
  assetTypes: AssetType[]
): T[] => {
  if (!assetTypes.length) {
    return assets;
  }

  return assets.filter(asset =>
    assetMatchesAssetTypes(
      asset,
      assetTypes.map(({ id, name }) => ({
        id: id ?? undefined,
        name: name ?? undefined,
      }))
    )
  );
};

export const retainSelectedAssetsForTypeChange = <T extends AssetWithType>({
  assets,
  assetTypes,
  hasLockedAssets,
}: {
  assets: T[] | undefined;
  assetTypes: AssetType[];
  hasLockedAssets: boolean;
}): T[] | undefined => {
  if (hasLockedAssets) {
    return assets;
  }

  if (!assets?.length || !assetTypes.length) {
    return undefined;
  }

  const matchingAssets = filterAssetsByTypes(assets, assetTypes);
  return matchingAssets.length ? matchingAssets : undefined;
};
